exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".soproni_small[data-v-2f9e256a]{padding-top:0}.new_soproni_small_area[data-v-2f9e256a]{margin-top:20px}.col-centered[data-v-2f9e256a]{float:none;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f9e256a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/app/main/components/pages/list/Promoted.vue
// module id = 69
// module chunks = 0 1 2